import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { PageHead, StatusBadge } from "../../components/Bits";

export default function CustomerHome() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/inspections").then(({ data }) => setList(data)); }, []);
  return (
    <div className="mx-auto max-w-4xl">
      <PageHead over="Customer" title="My inspection reports" />
      <div className="space-y-3">
        {list?.length === 0 && <p className="text-slate-500" data-testid="customer-empty">No reports yet.</p>}
        {list?.map((i) => (
          <Link key={i.inspection_id} to={i.status === "completed" ? `/customer/report/${i.inspection_id}` : "#"} data-testid={`customer-report-${i.inspection_id}`}
            onClick={(e) => i.status !== "completed" && e.preventDefault()}
            className={`tap flex items-center gap-4 rounded-lg border border-slate-200 bg-white p-5 ${i.status === "completed" ? "hover:border-teal-600" : "cursor-default opacity-70"}`}>
            <div className="grid h-11 w-11 place-items-center rounded-md bg-slate-900 text-teal-300"><FileText className="h-5 w-5" /></div>
            <div className="flex-1">
              <div className="font-semibold">{i.property.project} · {i.property.flat}</div>
              <div className="font-mono text-xs text-slate-500">{i.inspection_id} · {i.inspection_date}</div>
            </div>
            <StatusBadge status={i.status} />
            {i.status === "completed" ? <span className="font-display text-xl font-extrabold">{i.summary?.score}</span> : <span className="font-mono text-[10px] text-slate-500">REPORT PENDING</span>}
            <ArrowRight className="h-4 w-4 text-slate-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
